/*
offers pick generic template V1
for GWP, PWP & Pick
Collects the offer from the CMS
and makes a series of RPC calls
to gather data and populate
using a mustache template
*/

var generic = generic || {};
var site = site || {};
site.offerspick = site.offerspick || {};
site.template = site.template || {};
var $offerpick_action;
var $offerpick_continue;
var $offerpick_continue_promo;
var Mustache = Mustache || {};

site.offerspick = {
  offerCodes: [],
  productData: {},
  multiSkuProducts: {},
  selectedSkus: {},
  transData: {
    offers: [],
    samples: []
  },
  messages: {},
  options: {},
  attached: false,
  init: function (context) {
    var self = this;
    $('.offerspick', context).each(function () {
      var offercode = $(this).data('offercode');
      self.offerCodes.push(offercode);
      self.options[offercode] = {};
      self.options[offercode].imageFields = {
        product: {
          small: ['IMAGE_S', 'SMALL_IMAGE'],
          medium: ['IMAGE_M', 'MEDIUM_IMAGE'],
          large: ['IMAGE_L', 'LARGE_IMAGE']
        },
        sku: {
          small: ['IMAGE_S', 'SMALL_IMAGE'],
          medium: ['IMAGE_M', 'MEDIUM_IMAGE'],
          large: ['IMAGE_L', 'LARGE_IMAGE']
        }
      };
      self.options[offercode].container = this;
      self.options[offercode].dropdown = $(this).data('dropdown');
      self.options[offercode].imageType = $(this).data('image-type');
      self.options[offercode].imageSize = $(this).data('image-size');
      self.options[offercode].carousel = $(this).data('carousel');
      self.options[offercode].hide_samples = $(this).data('hide-samples');
      self.options[offercode].trigger_minicart = $(this).data('trigger-minicart');
      self.selectedSkus[offercode] = [];
      self.options[offercode].headerText = $('.offerspick__header__choices', this).text();
      self.options[offercode].displayOos = 0;

      $offerpick_action = $('.offerspick-action-buttons', document);
      $offerpick_continue = $('.js-offerspick__button--continue', this);
      $offerpick_continue_promo = $('.js-offerspick__button--continue_promo', this);
    });

    var params = {
      offers: self.offerCodes,
      get_products: 1,
      get_transaction: 1,
      get_messages: 1
    };
    self.getOffersData(params, function (response) {
      var offers = response.getValue() ? response.getValue().offers : [];
      if (_.isEmpty(offers)) {
        return;
      }
      var offersProducts = response.getValue().offersProducts;
      var trans = response.getValue().transaction;
      if (trans) {
        self.transData.offers = trans.offerCodes || [];
        self.transData.samples = trans.order ? trans.order.samples || [] : [];
      }
      if (!_.isEmpty(response.getValue().messages)) {
        self.messages = response.getValue().messages;
      }
      $.each(self.offerCodes, function (i, offercode) {
        var offer = offers[offercode];
        if (!offer || offer.timing !== 'active') {
          return true;
        }
        var benefits = offer.benefits || [];
        $.each(benefits, function (j, benefit) {
          if (benefit.class === 'ChoiceOfSkus') {
            self.options[offercode].choices = benefit.choices;
            // set header to reflect max allowed
            self.options[offercode].max_allowed = benefit.max_allowed;
            self.options[offercode].max_to_show = benefit.max_to_show;
            self.options[offercode].display_oos_skus = benefit.display_oos_skus;
            return false;
          }
        });
        self.preSortProducts(offersProducts, offercode);
        self.setHeaderText(offercode);
        //add threshold message if any
        self.showThresholdMessages(offercode);
      });
    });
  },
  getOffersData: function (params, callback) {
    generic.jsonrpc.fetch({
      method: 'offers.getOffersRpcData',
      params: [params],
      onBoth: callback
    });
  },
  preSortProducts: function (data, offercode) {
    var self = this;
    if (_.isEmpty(data.skus) || !data.skus[offercode].length) {
      return;
    }
    self.productData[offercode] = [];
    self.multiSkuProducts[offercode] = [];
    var skusInOffer = [];
    var prodIds = [];
    $.each(data.skus[offercode], function (index, sku) {
      skusInOffer.push(sku.SKU_ID);
      prodIds.push(sku.PRODUCT_ID);
      if (self.options[offercode].dropdown) {
        var prodIdCount = _.countBy(prodIds);
        if (prodIdCount[sku.PRODUCT_ID] > 1) {
          self.multiSkuProducts[offercode].push(sku.PRODUCT_ID);
        }
      }
      var selectedSkus = [sku];
      if (data.products[sku.PRODUCT_ID].skus.length > 1) {
        // check against full products
        if ($.inArray(sku.PRODUCT_ID, self.multiSkuProducts[offercode]) > -1) {
          // only use skus in skusInOffer
          selectedSkus = [];
          $.each(data.products[sku.PRODUCT_ID].skus, function (index, sku) {
            if ($.inArray(sku.SKU_ID, skusInOffer) > -1) {
              selectedSkus.push(sku);
            }
          });
        }
      }
      self.productData[offercode].push($.extend({}, data.products[sku.PRODUCT_ID], { skus: selectedSkus }));
    });
    // cms option to show skus as
    // a product with dropdown (multi-sku)
    if (self.options[offercode].dropdown) {
      // remove duplicates if multi-sku
      var seenProducts = [];
      self.productData[offercode] = self.productData[offercode].filter(function (prod) {
        if (!seenProducts.includes(prod.PRODUCT_ID)) {
          seenProducts.push(prod.PRODUCT_ID);
          return true;
        }
        return false;
      });
    }
    self.renderProducts(offercode);
  },
  getTemplateContent: function (key, data) {
    data = data || false;

    var html = $("div.inline-template[path='" + key + "']").html();
    if (html.length < 1) {
      return $();
    }

    // If there's no data object passed in, then just return a basic jquery element
    if (data === false) {
      return $(html);
    }

    // Added as Clinique doesn't load sites.template.render()
    if (!$.isFunction(site.template.render)) {
      return $(Mustache.render(html, data));
    } else {
      return site.template.render(html, data);
    }
  },
  renderProducts: function (offercode) {
    var self = this;

    // limit products displayed to max allowed
    self.productData[offercode] = self.productData[offercode].slice(0, self.options[offercode].max_to_show);

    $.each(self.productData[offercode], function (index, product) {
      var data = {};
      data.singleSku = product.skus.length > 1 ? 0 : 1;
      data.multiSku = product.skus.length > 1 ? 1 : 0;

      data.product = product;

      // inventory
      // get out of stock items
      var notShoppable = [];
      data.oos = false;
      if (self.options[offercode].display_oos_skus) {
        data.oos = _.every(product.skus, function (sku) {
          return !sku.isOrderable;
        });
      } else {
        notShoppable = _.filter(product.skus, function (sku) {
          return !sku.isOrderable;
        });
      }
      var shoppable = _.difference(product.skus, notShoppable);
      data.skus = shoppable;

      // images
      var type = self.options[offercode].imageType;
      if (data.skus.length > 1) {
        // multi-sku
        type = 'product';
      }
      var offerImageSize = self.options[offercode].imageSize;
      // prodcat values may need to be changed by brand
      var i;
      if (type === 'product') {
        var productImgSizes = self.options[offercode].imageFields.product[offerImageSize];
        for (i = productImgSizes.length; i--; ) {
          if (_.isUndefined(data.product[productImgSizes[i]])) {
            continue;
          }
          data.image = data.product[productImgSizes[i]];
        }
      } else {
        var skuImgSizes = self.options[offercode].imageFields.sku[offerImageSize];
        for (i = skuImgSizes.length; i--; ) {
          if (_.isUndefined(data.skus[0][skuImgSizes[i]])) {
            continue;
          }
          data.image = data.skus[0][skuImgSizes[i]];
        }
      }

      var offer = self.getTemplateContent('gwp_pwp_offers_pick_item', data);
      $('.offerspick__offers', self.options[offercode].container).append(offer);
    });

    if (self.options[offercode].carousel) {
      self.initSlickSlider(offercode);
    }
    // check inventory
    self.checkCart(offercode);
  },
  showThresholdMessages: function (offercode) {
    var self = this;
    if (!_.isEmpty(self.messages[offercode])) {
      var $messagesContainer = $('.js-footer-messages', self.options[offercode].container);
      $messagesContainer.html('');
      if (self.isOfferInCart(offercode)) {
        $.each(this.messages[offercode], function (index, message) {
          $messagesContainer.append('<p>' + message + '</p>');
        });
      }
    }
  },
  setHeaderText: function (offercode) {
    var headerText = this.options[offercode].headerText;
    headerText = headerText.replace(':count:', this.options[offercode].max_allowed);
    headerText = headerText.replace(':selected:', this.selectedSkus[offercode].length);
    if (this.options[offercode].max_allowed === 1) {
      var sampleSingularText =
        typeof site.translations.product.sample_singular_text !== 'undefined'
          ? site.translations.product.sample_singular_text
          : 'sample';
      var samplePluralText =
        typeof site.translations.product.sample_plural_text !== 'undefined'
          ? site.translations.product.sample_plural_text
          : 'samples';
      headerText = headerText.replace(samplePluralText, sampleSingularText);
    }
    $('.offerspick__header__choices', this.options[offercode].container).text(headerText).removeClass('hidden');
  },
  isOfferInCart: function (offercode) {
    return this.transData.offers.indexOf(offercode) !== -1;
  },
  checkCart: function (offercode) {
    var self = this;

    if (!self.transData.offers.length || !self.transData.samples.length) {
      self.cartActions(offercode);
      return;
    }
    // is item already in cart?
    $.each(self.transData.offers, function (index, offer) {
      if (offer !== offercode) {
        return true; // continue;
      }
      $.each(self.transData.samples, function (index, sample) {
        // sample.sku.SKU_BASE_ID
        var cartSku = sample['sku.SKU_BASE_ID'];
        var $selected = $('.js-add-offer[data-sku-base-id="' + cartSku + '"]', self.options[offercode].container);
        if ($selected.length) {
          self.selectedSkusPush(cartSku, offercode);
        }
        // check multi-sku
        var $multiSelect = $(
          ".js-offerspick__shade__select option[value='" + cartSku + "']",
          self.options[offercode].container
        );
        if ($multiSelect.length > 0) {
          self.selectedSkusPush(cartSku, offercode);
        }
      });
    });
    self.cartActions(offercode);
  },
  cartActions: function (offercode) {
    var self = this;

    // shade select
    var $select = $('.js-offerspick__shade__select', self.options[offercode].container);
    $select.change(function (event) {
      var skuBaseId = $(this).val();
      var $closest = $(this).closest('.offerspick__offer');
      var $addBtn = $('.js-add-offer', $closest);
      var $removeBtn = $('.js-remove-offer', $closest);
      // data not behaving, using attr
      $addBtn.attr('data-sku-base-id', skuBaseId);
      $removeBtn.attr('data-sku-base-id', skuBaseId);
      // If we already have the shade in the cart then set is_selected otherwise remove it
      self.offerSelected(offercode, false);
    });
    // add to cart
    var $addBtns = $('.js-add-offer', self.options[offercode].container);
    $addBtns.once().click( _.debounce(function () {
      if (!$(this).hasClass('button--disabled')) {
        // Disable the button to prevent further clicks
        $addBtns.addClass('button--disabled');
        $addBtns.attr('disabled', true);
        var skuBaseId = parseInt($(this).attr('data-sku-base-id'));
        self.selectedSkusPush(skuBaseId, offercode);
        self.addOfferCart(offercode);

        if ($offerpick_action.length) {
          $offerpick_action.removeClass('hidden');
        }
        $offerpick_continue.addClass('hidden');
        $offerpick_continue_promo.removeClass('hidden');
      }
    }, 500));
    // remove from cart
    var $removeBtns = $('.js-remove-offer', self.options[offercode].container);
    $removeBtns.once().click(function (event) {
      var skuBaseId = $(this).attr('data-sku-base-id');
      // needs to be a number for comparison
      skuBaseId = parseInt(skuBaseId);
      self.selectedSkus[offercode] = _.without(self.selectedSkus[offercode], skuBaseId);
      self.removeOfferCart(offercode);
      if (self.selectedSkus[offercode].length < 1) {
        if ($offerpick_action.length) {
          $offerpick_action.addClass('hidden');
        }
        $offerpick_continue.removeClass('hidden');
        $offerpick_continue_promo.addClass('hidden');
      }
      // Enable only the related js-add-offer button
      $(this).closest('.offerspick__offer').find('.js-add-offer').removeClass('button--disabled').removeAttr('disabled');
    });

    $('.js-offerspick__header__url', self.options[offercode].container)
      .once()
      .click(function (event) {
        event.preventDefault();
        self.selectedSkus[offercode] = [];
        self.removeOfferCart(offercode);
      });

    // already in cart
    if (self.selectedSkus[offercode] && self.selectedSkus[offercode].length) {
      self.offerSelected(offercode, true);
    } else {
      $(document).trigger('wpSelected', false);
    }
  },
  getMessages: function () {
    var self = this;
    var params = {
      offers: self.offerCodes,
      get_transaction: 1,
      get_messages: 1
    };
    self.getOffersData(params, function (response) {
      if (_.isEmpty(response.getValue().messages)) {
        return;
      }
      self.messages = response.getValue().messages;
      var trans = response.getValue().transaction;
      if (trans) {
        self.transData.offers = trans.offerCodes;
      }
      $.each(self.offerCodes, function (i, offercode) {
        self.showThresholdMessages(offercode);
      });
    });
  },
  addOfferCart: function (offercode) {
    var self = this;
    // offer.apply
    var params = {
      offer_code: offercode,
      benefits: {
        ChoiceOfSkus: {
          choices: self.selectedSkus[offercode]
        }
      }
    };

    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: [params],
      onBoth: function (response) {
        var offer = response.getValue();
        if (offer && offer.inCart) {
          self.offerSelected(offercode, true);
          self.getMessages();
          if (self.options[offercode].trigger_minicart) {
            self.cartConfirm();
          }
          if (self.options[offercode].hide_samples) {
            generic.cookie('stopSampleChoice', '1');
          }
        }
      }
    });
  },
  removeOfferCart: function (offercode) {
    var self = this;

    if (self.selectedSkus[offercode].length) {
      // we have selected items, reapply offer
      self.addOfferCart(offercode);
    } else {
      // no items, remove all
      var params = {
        offer_code: offercode
      };

      generic.jsonrpc.fetch({
        method: 'offer.removeOfferByCode',
        params: [params],
        onBoth: function (response) {
          var offer = response.getValue();
          if (offer && !offer.inCart) {
            self.offerRemoved(offercode);
            self.getMessages();
          }
          $(document).trigger('loadCart.success', true);
        }
      });
    }
  },
  offerSelected: function (offercode, isDefault) {
    var self = this;
    var isSelected = false;
    $('.offerspick__offer', self.options[offercode].container).removeClass('is_selected').removeClass('not_selected');

    var isMax = self.selectedSkus[offercode].length === self.options[offercode].max_allowed ? 1 : 0;
    if (isMax) {
      $('.js-add-offer', self.options[offercode].container).addClass('button--disabled');
      $('.offerspick__header__choices', self.options[offercode].container).addClass('hidden');
      $('.offerspick__header__remove', self.options[offercode].container).removeClass('hidden');
    } else {
      $('.js-add-offer', self.options[offercode].container).removeClass('button--disabled');
      $('.offerspick__offer', self.options[offercode].container).removeClass('not_selected');
      $('.offerspick__header__remove', self.options[offercode].container).addClass('hidden');
      $('.offerspick__header__choices', self.options[offercode].container).removeClass('hidden');
    }
    $.each(self.selectedSkus[offercode], function (index, skuBaseId) {
      var $selected = $(
        '.js-add-offer[data-sku-base-id="' + skuBaseId + '"]',
        self.options[offercode].container
      ).closest('.offerspick__offer');
      var $multiSelect = $(
        ".js-offerspick__shade__select option[value='" + skuBaseId + "']",
        self.options[offercode].container
      );
      if ($multiSelect.length && isDefault) {
        var $closest = $multiSelect.closest('.offerspick__offer');
        $('.js-offerspick__shade__select', $closest).val(skuBaseId);
        $closest.addClass('is_selected');
        $('.js-add-offer', $closest).attr('data-sku-base-id', skuBaseId);
        $('.js-remove-offer', $closest).attr('data-sku-base-id', skuBaseId);
        if (isMax) {
          $closest.removeClass('button--disabled');
        }
      }
      if (isMax) {
        $selected.removeClass('button--disabled');
      }
      $selected.addClass('is_selected');
      isSelected = true;
    });
    if (isSelected) {
      if (isMax) {
        $('.offerspick__offer', self.options[offercode].container).not('.is_selected').addClass('not_selected');
      }
      if ($offerpick_action.length) {
        $offerpick_action.removeClass('hidden');
      }
      $offerpick_continue.addClass('hidden');
      $offerpick_continue_promo.removeClass('hidden');
    }
    self.setHeaderText(offercode);
    $(document).trigger('wpSelected', isSelected);
  },
  offerRemoved: function (offercode) {
    $('.js-add-offer', this.options[offercode].container).removeClass('button--disabled');
    $('.offerspick__offer', this.options[offercode].container).removeClass('is_selected').removeClass('not_selected');
    $('.offerspick__header__remove', this.options[offercode].container).addClass('hidden');
    $('.offerspick__header__choices', this.options[offercode].container).removeClass('hidden');
    $('.offerspick__footer', this.options[offercode].container).removeClass('visible');
    this.setHeaderText(offercode);
    $(document).trigger('wpSelected', false);
  },
  cartConfirm: function () {
    generic.jsonrpc.fetch({
      method: 'trans.get',
      params: [
        {
          trans_fields: ['TRANS_ID', 'totals'],
          payment_fields: [],
          order_fields: ['items', 'samples', 'offerCodes']
        }
      ],
      onSuccess: function (d) {
        var cartResponse = d.getValue();
        if (typeof cartResponse === 'undefined' || !cartResponse) {
          return;
        }
        var args = {
          trans: cartResponse,
          items: cartResponse.order.items
        };
        // trigger event in gnav_pick_v1.js
        // addOffer, modification of addCart
        // issues still exist on genie,
        // cart does not fully represent samples
        $(document).trigger('offerToCart.success', args);
      },
      onError: function () {}
    });
  },
  selectedSkusPush: function (skuBaseId, offercode) {
    var self = this;
    // function to normalize value type of selectedSkus
    skuBaseId = parseInt(skuBaseId);
    self.selectedSkus[offercode].push(skuBaseId);
  },
  initSlickSlider: function (offercode) {
    var $slideWrap = $('.offerspick__offers', this.options[offercode].container);
    var slideOptions = {
      speed: 300,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    $slideWrap.slick(slideOptions);
    $slideWrap.on('setPosition', function () {
      $slideWrap.find('.slick-slide').matchHeight();
    });
  }
};

(function ($) {
  Drupal.behaviors.offersPickV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      site.offerspick.init(context);
    }
  };
})(jQuery);
